<template>
  <div class="kurs-includes">
    <h2
      v-if="examCenyPage"
      class="title-primary"
    >
      16 уроков уже доступны <br> на платформе бесплатно
    </h2>
    <h2
      v-else
      class="title-primary"
    >
      Курс включает в&nbsp;себя
    </h2>

    <p class="kurs-includes__text">
      Узнаешь ,как легко пройти порог и&nbsp;не переживать за&nbsp;ЕГЭ, как решать тестовую
      часть и&nbsp;самые сложные темы профильной математики и&nbsp;русского языка, чтобы пробить
      планку в&nbsp;85+&nbsp;баллов на&nbsp;ЕГЭ. Бонус всем участникам от&nbsp;наших учителей:
      авторские секреты и&nbsp;фишки, которые позволят вам сдать ЕГЭ на&nbsp;высокий балл без
      стресса и&nbsp;тревоги!
    </p>

    <div class="kurs-includes__item kurs-includes__item-1">
      <h5>
        <span>8 уроков</span>
        с детальным разбором ЕГЭ 2024
        <span>по&nbsp;русскому языку</span>
      </h5>

      <button
        v-if="examCenyPage"
        class="m-btn"
        @click="kursModal = true"
      >
        Получить доступ бесплатно
      </button>
      <button
        v-else
        class="m-btn"
        @click="$emit('openProgram', 'rus')"
      >
        Посмотреть темы уроков
      </button>
    </div>
    <div class="kurs-includes__item kurs-includes__item-2">
      <h5>
        <span>8 уроков</span>
        с детальным разбором ЕГЭ 2024
        <span>по&nbsp;проф. математике</span>
      </h5>

      <button
        v-if="examCenyPage"
        class="m-btn"
        @click="kursModal = true"
      >
        Получить доступ бесплатно
      </button>
      <button
        v-else
        class="m-btn"
        @click="$emit('openProgram', 'math')"
      >
        Посмотреть темы уроков
      </button>
    </div>
    <div class="kurs-includes__item kurs-includes__item-3">
      <h5>
        Стратегия подготовки  от 0 до 100, лайфхаки, шпаргалки
      </h5>
      <p>
        &laquo;Welcome box&raquo; из&nbsp;4-х полезных файлов для всех подключившихся
        и&nbsp;еще много полезного в&nbsp;нашем ЕГЭ-комьюнити
      </p>
    </div>

    <kurs-modal
      v-if="kursModal"
      @closeModal="kursModal = false"
    />
  </div>
</template>

<script>
import KursModal from './KursModal.vue';

export default {
  name: 'KursIncludes',
  components: { KursModal },
  data: () => ({
    kursModal: false,
  }),
  computed: {
    examCenyPage() {
      const routeNameCondition = [
        'ege-ceny',
        'oge-ceny',
        'ege',
      ].includes(this.$route.name);

      const paramsCondition = this.$route.name === 'ege-subpage' && [
        'matematika-profil',
        'matematika',
        'russkij-yazyk',
        'anglijskij-yazyk',
        'informatika',
        'istoriya',
        'obshchestvoznanie',
        'biologiya',
        'fizika',
        'himiya',
        'literatura',
      ].includes(this.$route.params?.subpage);

      return routeNameCondition || paramsCondition;
    },
  },
};
</script>

<style scoped lang="scss">

.kurs-includes {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  @include media-down(tablet) {
    grid-template-columns: repeat(1, 1fr);
    gap: 12px;
  }

  .title-primary {
    margin-bottom: 20px;
    letter-spacing: -0.02em;

    @include media-down(laptop) {
      font-size: 45px;
    }

    @include media-down(tablet) {
      padding: 0 8px;
      margin-bottom: 0;
      font-size: 35px;
    }
  }

  .kurs-includes__text {
    font-weight: 500;
    font-size: 18px;
    line-height: 130%;
    letter-spacing: -0.01em;
    font-feature-settings: 'pnum' on, 'lnum' on;
    color: $grey2;

    @include media-down(tablet) {
      padding: 0 8px;
      margin-bottom: 20px;

      font-size: 16px;
      letter-spacing: -0.02em;
    }
  }

  .kurs-includes__item {
    padding: 40px 80px 35px 40px;

    background-color: $white-color;
    box-shadow: 10px 10px 50px rgba($ege-blue-darkest, 0.1), 4px 4px 20px rgba($ege-blue-darkest, 0.05);
    border-radius: 40px;

    @include media-down(laptop) {
      padding: 40px 30px 35px 30px;
    }

    @include media-down(mobile) {
      display: flex;
      flex-direction: column;

      min-height: 200px;
      padding: 20px 20px 16px;

      border-radius: 20px;
      box-shadow: 10px 10px 22px rgba($ege-blue-darkest, 0.1), 4px 4px 14px rgba($ege-blue-darkest, 0.05);
    }
  }

  h5 {
    font-weight: 700;
    font-size: 40px;
    line-height: 90%;
    letter-spacing: -0.03em;
    text-transform: uppercase;
    font-feature-settings: 'case' on;

    @include media-down(mobile) {
      max-width: 304px;
      font-size: 25px;
      line-height: 1.1;
    }
  }

  button {
    margin-top: 53px;

    display: flex;
    gap: 6px;
    align-items: center;

    position: relative;
    overflow: hidden;

    color: $black;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    font-feature-settings: 'pnum' on, 'lnum' on;

    @include media-down(mobile) {
      margin-top: auto;
      font-size: 18px;
    }

    &::before {
      content: '';
      width: 13px;
      height: 18px;
      display: block;
      background-image: url("/v2/kurs/includes/arrow.svg");
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;

      @include media-down(mobile) {
        margin-top: -2px;
      }
    }

    &::after {
      content: '';
      width: 100%;
      height: 2px;

      position: absolute;
      bottom: 0;
      left: 120%;
      background-color: $black;

      transition: 300ms;
    }

    @media (hover: hover) {
      &:hover::after {
        left: 0;
      }
    }
  }

  .kurs-includes__item-1 h5 span {
    color: #D56FAC;
  }

  .kurs-includes__item-2 h5 span {
    color: #E3B692;
  }

  .kurs-includes__item-3 {
    grid-column: 2/3;
    grid-row: 2/4;
    background-image: url("/v2/kurs/includes/img.webp");
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: bottom right;

    @include media-down(tablet) {
      min-height: 400px;
      grid-column: 1/2;
      grid-row: 5/6;
      background-image: url("/v2/kurs/includes/img-mob.webp");
      background-size: 440px;
      background-position: bottom -95px right -60px;
    }

    h5 {
      color: #FF4F01;
    }

    p {
      max-width: 275px;
      margin-top: 20px;

      font-weight: 500;
      font-size: 18px;
      line-height: 130%;
      letter-spacing: -0.01em;
      font-feature-settings: 'pnum' on, 'lnum' on;
      color: $grey2;

      @include media-down(tablet) {
        max-width: 400px;
        margin-top: 6px;
        font-size: 20px;
      }
    }
  }
}

</style>
